import React from 'react';
import { observer } from 'mobx-react-lite';
import {
    HeaderWrapper,
    SearchInputWrapper,
    SearchInput,
    BlockTitle,
    SearchIconWrapper,
} from './HeaderAndSearch.styles';
import { useAppStateContext } from 'src/AppState/AppState';

interface HeaderAndSearchPropsType {
    // onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    blockTitle: string;
    // itemsNumber: number;
    placeholder: string;
    // valueForInput: string;
    min?: number;
}

export const HeaderAndSearch = observer((props: HeaderAndSearchPropsType) => {
    const { automaticWithdrawalState } = useAppStateContext();
    const { blockTitle, placeholder, min } = props;
    return (
        <HeaderWrapper>
            <BlockTitle>{`${automaticWithdrawalState.numberOfItems} ${blockTitle}`}</BlockTitle>
            <SearchInputWrapper>
                <SearchIconWrapper />
                <SearchInput
                    type='number'
                    placeholder={placeholder}
                    onChange={automaticWithdrawalState.searchByAccountNumber}
                    value={automaticWithdrawalState.searchValue}
                    min={min}
                    data-test='search-input'
                />
            </SearchInputWrapper>
        </HeaderWrapper>
    );
});
